// One team logo: uploaded image (/api/teams/:id/avatar?v=<file version>) → logo_url → coloured initial.
// The ?v= changes with every upload, so the image can be cached and a new one still shows at once.
import React, { useState } from 'react';

const COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4', '#ec4899', '#14b8a6'];
export function teamColor(name) {
  let h = 0;
  for (const ch of String(name || '')) h = (h * 31 + ch.charCodeAt(0)) | 0;
  return COLORS[Math.abs(h) % COLORS.length];
}

export default function TeamLogo({ team, size = 34, radius = 8 }) {
  const [broken, setBroken] = useState(false);
  const src = !broken && team && team.avatar_v
    ? `/api/teams/${team.id}/avatar?v=${team.avatar_v}`
    : (!broken && team && team.logo_url ? team.logo_url : null);
  const box = { width: size, height: size, borderRadius: radius, flexShrink: 0, overflow: 'hidden', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' };
  if (src) {
    return (
      <span style={{ ...box, background: 'rgba(255,255,255,0.04)', border: '1px solid var(--border-subtle)' }}>
        <img src={src} alt="" loading="lazy" onError={() => setBroken(true)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </span>
    );
  }
  const c = teamColor(team && team.name);
  return (
    <span style={{ ...box, background: `${c}22`, border: `1px solid ${c}55`, color: c, fontWeight: 800, fontSize: size * 0.42 }} aria-hidden="true">
      {String((team && team.name) || '?').trim().charAt(0).toUpperCase()}
    </span>
  );
}
